export default __webpack_public_path__ + "6f836359576059bf8049e83e298e478e.svg";